
import { HASHTAGS } from "../../../type/EnumHashtags";
import { BRAND } from "../../../type/EnumBrand";
import { IProductData } from "../../../type/IProductData";

export const dlc500: IProductData = {
  id: "hazelriggindustries-dlc",
  name: "Hazelrigg Industries DLC",
  description: "DLC Vacuum Tube Inductor Equalizer",
  specialOrder: true,
  images: ["/img/hazelriggindustries_dlc_front.jpg", "/img/hazelriggindustries_dlc_side.jpg"],
  details: [{
    label: "Description",
    markdown: `
The DLC is based on the passive equalizer circuit in the Hazelrigg Industries VLC (originally found in the D.W. Fearn VT-5).  
It shares the same filter capacitors and handwound inductor as the VLC, though the audio path is slightly different.  
The input audio circuit comes from the D.W. Fearn VT-2, while the output uses a low THD/high gain solid state amplifier design.  
Like the VLC, the DLC uses transformers in both input and output stages.  

User tips: Boosting and cutting simultaneously can create complex equalization curves.  
Try turning up all knobs except the bass boost, switch frequencies to the desired settings, then bring the bass boost up until the sound is balanced.  
`
  }, {
    label: "Features",
    markdown: `
- Vacuum Tube Input Stage (6072a)
- Hand-wound Inductor
- Amplifier and EQ Circuits Designed By D.W. Fearn
- 7 Year Warranty (90 Days For Vacuum Tubes)
- Transformers in Both Input and Output Stages
- Front Panel Microphone/Instrument Input
- High Cut Control
- High Boost Control
- Low Boost Control
- Low Cut Control
- High Cut Freq. Select Switch
- High Boost Freq. Select Switch
- Low Boost Freq. Select Switch
- Low Cut Freq. Select Switch
- Bypass Switch
    `
  }, {
    label: "Manufacturer Links",
    markdown: `
- <a to="https://www.hazelriggindustries.com/hazelriggdseries" target="_blank">https://www.hazelriggindustries.com/hazelriggdseries</a>
- <a to="https://static1.squarespace.com/static/610da5f698ae9050ada60fb8/t/670524bc3dbf934c5a519711/1728390332954/D+series+manuals.pdf" target="_blank">Manual</a>
    `
  }],
  videos: [],
  metadata: {
    hashtags: [HASHTAGS.LIVE_SOUND, HASHTAGS.MIXING, HASHTAGS.RECORDING, HASHTAGS.API_500, HASHTAGS.SINGLE_SLOT, HASHTAGS.EQ],
    manufacturer: BRAND.HAZELRIGG,
  }
}